import Components from './Location.vue';

const location = {
    install:function(Vue) {
        Vue.component('location', Components)
    }
}

export default location;